// @module C3.ShoppingExtensions.InventoryList
define('C3.ShoppingExtensions.CartPage.ProductList.DetailsLater.View'
,	[
	     'c3_shoppingextensions_cartpage_productlist_detailslater.tpl',
		 'products_detail_later_cell.tpl',
		 'backbone_collection_view_row.tpl',
		 'Utils',
		 'jQuery', 
		 'Profile.Model',
		 'ProductList.DetailsLaterMacro.View',
		 'ProductList.Details.View',
		 'ProductList.Deletion.View',
		 'Backbone.CollectionView',
		 'LiveOrder.Model',
		 'Backbone.View',
		 'jQuery.sidebarPDPWishListMenu'
    ]
, function (
	    c3_shoppingextensions_cartpage_productlist_detailslater_tpl,
		products_detail_later_cell_tpl,
		backbone_collection_view_row_tpl,
		Utils,
		jQuery,
		ProfileModel,
		ProductListDetailsLaterMacroView,
		ProductListDetailsView,
		ProductListDeletionView,
		BackboneCollectionView,
		LiveOrderModel,
		BackboneView
)
{
    'use strict';

    let product_list_promise;

	// @class C3.ShoppingExtensions.InventoryList.View @extends Backbone.View
	return BackboneView.extend({

		template: c3_shoppingextensions_cartpage_productlist_detailslater_tpl

	,	initialize: function (options) {

			this.options = options;
	        this.application = options.application;
	        this.cart = LiveOrderModel.getInstance();

	        this.model.on('change', this.render, this);

	        this.model.get('items').on('add remove change reset', this.render, this);

	        this.promise = this.loadProductList();
		}


	,  events: {
        // items events
        'click [data-action="add-to-cart"]': 'addItemToCartHandler',
        'click [data-action="delete-item"]': 'askDeleteListItem',
        'change [data-action="change-quantity"]': 'updateItemQuantity',
        'keyup [data-action="change-quantity"]': 'updateItemQuantity',
        'click [data-ui-action="add"]': 'addQuantity',
        'click [data-ui-action="minus"]': 'subQuantity'
    }	


	,   render: function() {
        if (ProfileModel.getInstance().get('isLoggedIn') === 'T') {
            this._render();
            const pushable = this.$el.find('[data-action="pushable"]');
            pushable.scPush({
                selector: this.$el.find(
                    `[data-type="sc-pusher"][data-target="${pushable.data('id')}"]`
                )
            });
        } else {
            this.$el.empty();
        }

        return this;
    }

    ,  loadProductList: function() {
        const self = this;

        if (!product_list_promise) {
            ProfileModel.getPromise().done(function() {
                if (ProfileModel.getInstance().get('isLoggedIn') === 'T') {
                    const ProductListUtils = self.options.application.ProductListModule.Utils;
                    var targetListId = self.options.targetListId;
                   // product_list_promise = ProductListUtils.getSavedForLaterProductList();
                    product_list_promise = ProductListUtils.getProductList(targetListId);
                    product_list_promise.done(function(attributes) {
                            self.model.set(attributes);
                    });
                        }
            });
        }

        return product_list_promise;
    }

    ,  addItemToCartHandler: function(e) {
        e.stopPropagation();
        e.preventDefault();

        const selected_product_list_item_id = this.$(e.target)
            .closest('article')
            .data('id');
        const selected_product_list_item = this.model
            .get('items')
            .get(selected_product_list_item_id);
        const add_to_cart_promise = this.cart.addLine(selected_product_list_item);
        const whole_promise = jQuery.when(
            add_to_cart_promise,
            this.deleteListItem(selected_product_list_item)
        );

        this.disableElementsOnPromise(
            whole_promise,
            this.$(e.target)
                .closest('article')
                .find('button')
        );
    }

    ,  addQuantity: function(e) {
        e.preventDefault();

        const $element = jQuery(e.target);
        const oldValue = $element
            .parent()
            .find('input')
            .val();
        const newVal = parseFloat(oldValue) + 1;

        const input = $element.parent().find('input');

        input.val(newVal);
        input.trigger('change');
    }


    ,  subQuantity: function(e) {
        e.preventDefault();

        const $element = jQuery(e.target);
        const oldValue = $element
            .parent()
            .find('input')
            .val();
        let newVal = parseFloat(oldValue) - 1;

        newVal = Math.max(1, newVal);

        const input = $element.parent().find('input');

        input.val(newVal);
        input.trigger('change');
    }

    ,  askDeleteListItem: function(e) {
        e.stopPropagation();

        this.deleteConfirmationView = new ProductListDeletionView({
            application: this.application,
            parentView: this,
            target: e.target,
            title: Utils.translate('Delete selected items'),
            body: Utils.translate('Are you sure you want to remove selected items?'),
            confirmLabel: Utils.translate('Yes'),
            confirm_delete_method: 'deleteListItemHandler'
        });

        this.deleteConfirmationView.showInModal();
    }

    ,  deleteListItemHandler: function(target) {
        const self = this;
        const itemid = jQuery(target)
            .closest('article')
            .data('id');
        const product_list_item = this.model.get('items').findWhere({
            internalid: `${itemid}`
        });
        const success = function() {
            self.deleteConfirmationView.$containerModal
                .removeClass('fade')
                .modal('hide')
                .data('bs.modal', null);
            self.render();
            self.showConfirmationMessage(
                Utils.translate('The item was removed from your product list'),
                true
            );
        };

        self.model.get('items').remove(product_list_item);
        self.deleteListItem(product_list_item, success);
    }


    ,deleteListItem: ProductListDetailsView.prototype.deleteListItem

    ,disableElementsOnPromise: ProductListDetailsView.prototype.disableElementsOnPromise

    ,updateItemQuantity: ProductListDetailsView.prototype.updateItemQuantity

   , updateItemQuantityHelper: ProductListDetailsView.prototype.updateItemQuantityHelper

    , childViews: {
        'ProductList.DetailsLater.Collection': function() {
            return new BackboneCollectionView({
                collection: this.model.get('items'),
                childView: ProductListDetailsLaterMacroView,
                viewsPerRow: 4,
                cellTemplate: products_detail_later_cell_tpl,
                rowTemplate: backbone_collection_view_row_tpl,
                childViewOptions: {
                    application: this.application
                }
            });
        }
    }

		//@method getContext @return C3.ShoppingExtensions.InventoryList.View.Context
	,	getContext: function getContext()
		{
			const items = this.model.get('items');
        	const itemsLength = items.length;
			//console.log(this)
			return {
				itemsLength: itemsLength,
	            // @property {Boolean} hasItems
	            hasItems: itemsLength > 0,
	            // @property {Boolean} isEmpty
	            isEmpty: itemsLength === 0,
	            // @property {Boolean} hasMoreThanOneItem
	            hasMoreThanOneItem: itemsLength > 1
	            
			};
		}
	});
});
